import { PolicyAttachmentType } from '~domain/model/policy/attachment/policy-attachment-type';
import { CommonImages } from '~frontend-common/images';

export enum PolicyAttachmentCategory {
  Schedule = 'schedule',
  Billing = 'billing',
  Contract = 'contract',
  Certificate = 'certificate',
  Debug = 'debug',
  General = 'general',
}

type PolicyAttachmentCategoryConfig = {
  iconSrc: string;
  attachmentTypes: PolicyAttachmentType[];
};

export const policyAttachmentCategoryConfigs: Record<PolicyAttachmentCategory, PolicyAttachmentCategoryConfig> = {
  [PolicyAttachmentCategory.Schedule]: {
    iconSrc: CommonImages.policies.attachmentCategories.schedule,
    attachmentTypes: [
      PolicyAttachmentType.NewBusinessPaymentSchedule,
      PolicyAttachmentType.PolicyChangePaymentSchedule,
      PolicyAttachmentType.RenewalPaymentSchedule,
      PolicyAttachmentType.ReissuePaymentSchedule,
      PolicyAttachmentType.RewritePaymentSchedule,
      PolicyAttachmentType.ReinstatementPaymentSchedule,
      PolicyAttachmentType.PaymentScheduleNoPolicyTransaction,
    ],
  },
  [PolicyAttachmentCategory.Billing]: {
    iconSrc: CommonImages.policies.attachmentCategories.billing,
    attachmentTypes: [
      PolicyAttachmentType.BillingWithdrawalRejectionNotice,
      PolicyAttachmentType.BillingOverduePaymentNotice,
      PolicyAttachmentType.BillingFinalBillNotice,
      PolicyAttachmentType.BillingRefundIssued,
      PolicyAttachmentType.PaymentReceivedPolicyReinstated,
      PolicyAttachmentType.PaymentRequiredOutstandingBalance,
      PolicyAttachmentType.BillingCollectionNotice,
      PolicyAttachmentType.BillingCreditCardExpired,
      PolicyAttachmentType.BillingStatement,
      PolicyAttachmentType.BillingNotice,
    ],
  },
  [PolicyAttachmentCategory.Contract]: {
    iconSrc: CommonImages.policies.attachmentCategories.contract,
    attachmentTypes: [
      PolicyAttachmentType.NewBusinessPolicyDeclaration,
      PolicyAttachmentType.PolicyChangePolicyDeclaration,
      PolicyAttachmentType.RenewalPolicyDeclaration,
      PolicyAttachmentType.ReissuePolicyDeclaration,
      PolicyAttachmentType.RewritePolicyDeclaration,
      PolicyAttachmentType.ReinstatementPolicyDeclaration,
      PolicyAttachmentType.PolicyContract,
    ],
  },
  [PolicyAttachmentCategory.Certificate]: {
    iconSrc: CommonImages.policies.attachmentCategories.certificate,
    attachmentTypes: [
      PolicyAttachmentType.NewBusinessLiabilityCertificates,
      PolicyAttachmentType.PolicyChangeLiabilityCertificates,
      PolicyAttachmentType.RenewalLiabilityCertificates,
      PolicyAttachmentType.ReissueLiabilityCertificates,
      PolicyAttachmentType.RewriteLiabilityCertificates,
      PolicyAttachmentType.ReinstatementLiabilityCertificates,
    ],
  },
  [PolicyAttachmentCategory.General]: {
    iconSrc: CommonImages.policies.attachmentCategories.general,
    attachmentTypes: [
      PolicyAttachmentType.InsurerNonRenewal,
      PolicyAttachmentType.InsurerCancellationReinstatable,
      PolicyAttachmentType.InsurerCancellationDefinitive,
      PolicyAttachmentType.InsuredCancellationRequest,
      PolicyAttachmentType.InsurerCancellation,
      PolicyAttachmentType.UnderwritingRequest,
      PolicyAttachmentType.ClaimOpeningNotice,
      PolicyAttachmentType.ClaimClosingNotice,
      PolicyAttachmentType.ClaimAdjusterAssignment,
      PolicyAttachmentType.ClaimAutoRentalNotice,
      PolicyAttachmentType.ClaimTotalLossNotice,
      PolicyAttachmentType.ClaimAutoFaultDeterminationNotice,
      PolicyAttachmentType.ClaimPaymentNotice,
      PolicyAttachmentType.CancellationNotice,
      PolicyAttachmentType.Unknown,
    ],
  },
  [PolicyAttachmentCategory.Debug]: {
    iconSrc: CommonImages.policies.attachmentCategories.debug,
    attachmentTypes: [PolicyAttachmentType.OkEDelivery],
  },
};

export function getPolicyAttachmentCategory(type: PolicyAttachmentType): PolicyAttachmentCategory {
  return (
    (Object.keys(policyAttachmentCategoryConfigs).find((category: PolicyAttachmentCategory) =>
      policyAttachmentCategoryConfigs[category].attachmentTypes.includes(type),
    ) as PolicyAttachmentCategory) || PolicyAttachmentCategory.General
  );
}

export function getPolicyAttachmentCategoryIcon(type: PolicyAttachmentType): string {
  const category = getPolicyAttachmentCategory(type);
  return policyAttachmentCategoryConfigs[category]?.iconSrc;
}
